// src/pages/meeting/InvitationEGM_ENPage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import InvitationEGM_ENForm from "../../forms/anounce/InvitationEGM_EN/InvitationEGM_EN";

function InvitationEGM_ENPage() {
  return (
    <FormWrapper
      title="ประกาศเลิกบริษัทEnglishขั้นตอน1"
      FormComponent={InvitationEGM_ENForm}
      formKey="InvitationEGM_EN"
    />
  );
  }

export default InvitationEGM_ENPage;
